import { render, staticRenderFns } from "./DevFormReplace.vue?vue&type=template&id=df1126c0"
import script from "./DevFormReplace.vue?vue&type=script&lang=js"
export * from "./DevFormReplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports